module.exports = __webpack_public_path__ + "static/media/instructor-onboarding-image11.22ce3e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-onboarding-image11.png
// module id = 2634
// module chunks = 0